var _excluded = ["alwaysFetchColumns"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { IrisGrid, IrisGridCacheUtils, IrisGridUtils, isIrisGridTableModelTemplate } from '@deephaven/iris-grid';
import { useSelector } from 'react-redux';
import { getSettings } from '@deephaven/redux';
import { LoadingOverlay } from '@deephaven/components';
import { useLayoutManager, useListener, usePersistentState } from '@deephaven/dashboard';
import { assertNotNull, getErrorMessage } from '@deephaven/utils';
import { useApi } from '@deephaven/jsapi-bootstrap';
import { useIrisGridModel } from "./useIrisGridModel.js";
import useDashboardColumnFilters from "./useDashboardColumnFilters.js";
import { InputFilterEvent } from "./events/index.js";
import useGridLinker from "./useGridLinker.js";
import { useTablePlugin } from "./useTablePlugin.js";
/**
 * Props that can only be supplied by IrisGrid-aware middleware wrapping
 * `GridWidgetPlugin` (regular plugins receive only `WidgetComponentProps`).
 * Grouped together so the middleware-only surface is explicit; the component
 * depends on `Partial` of this so each prop stays optional.
 */
import { jsx as _jsx } from "react/jsx-runtime";
export function GridWidgetPlugin(_ref) {
  var _model$columns;
  var fetch = _ref.fetch,
    transformTableOptions = _ref.transformTableOptions,
    transformModel = _ref.transformModel,
    irisGridProps = _ref.irisGridProps,
    onModelChanged = _ref.onModelChanged;
  var settings = useSelector(getSettings);
  var _useLayoutManager = useLayoutManager(),
    eventHub = _useLayoutManager.eventHub;
  var fetchResult = useIrisGridModel(fetch, transformModel);
  var model = fetchResult.status === 'success' ? fetchResult.model : undefined;

  // Notify observers (e.g. middleware) when the built model changes.
  useEffect(() => {
    if (model != null) {
      onModelChanged === null || onModelChanged === void 0 || onModelChanged(model);
    }
  }, [model, onModelChanged]);
  var dh = useApi();
  var irisGridUtils = useMemo(() => new IrisGridUtils(dh), [dh]);
  var _usePersistentState = usePersistentState(undefined, {
      version: 1,
      type: 'GridWidgetPlugin'
    }),
    _usePersistentState2 = _slicedToArray(_usePersistentState, 2),
    state = _usePersistentState2[0],
    setState = _usePersistentState2[1];
  var initialState = useRef(state);
  var hydratedState = useMemo(() => {
    if (fetchResult.status !== 'success' || initialState.current === undefined) {
      return;
    }
    return _objectSpread(_objectSpread({}, irisGridUtils.hydrateIrisGridState(fetchResult.model, initialState.current)), IrisGridUtils.hydrateGridState(fetchResult.model, initialState.current));
  }, [fetchResult, irisGridUtils]);
  var dehydrateIrisGridState = useMemo(() => IrisGridCacheUtils.makeMemoizedCombinedGridStateDehydrator(), []);
  var handleIrisGridChange = useCallback((irisGridState, gridState) => {
    if (fetchResult.status !== 'success' || irisGridState == null || gridState == null) {
      return;
    }
    var newState = dehydrateIrisGridState(fetchResult.model, irisGridState, gridState);
    setState(newState);
  }, [fetchResult, setState, dehydrateIrisGridState]);
  var inputFilters = useDashboardColumnFilters((_model$columns = model === null || model === void 0 ? void 0 : model.columns) !== null && _model$columns !== void 0 ? _model$columns : null, model != null && isIrisGridTableModelTemplate(model) ? model.table : undefined);
  var irisGridRef = useRef(null);
  var _useGridLinker = useGridLinker(fetchResult.status === 'success' ? fetchResult.model : null, irisGridRef.current),
    linkerAlwaysFetchColumns = _useGridLinker.alwaysFetchColumns,
    linkerProps = _objectWithoutProperties(_useGridLinker, _excluded);
  var handleClearAllFilters = useCallback(() => {
    if (irisGridRef.current == null) {
      return;
    }
    irisGridRef.current.clearAllFilters();
  }, []);
  useListener(eventHub, InputFilterEvent.CLEAR_ALL_FILTERS, handleClearAllFilters);
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    selection = _useState2[0],
    setSelection = _useState2[1];
  var _useTablePlugin = useTablePlugin({
      model,
      irisGridRef,
      irisGridUtils,
      selectedRanges: selection
    }),
    Plugin = _useTablePlugin.Plugin,
    customFilters = _useTablePlugin.customFilters,
    filterFetchColumns = _useTablePlugin.alwaysFetchColumns,
    onContextMenu = _useTablePlugin.onContextMenu;
  var alwaysFetchColumns = useMemo(() => {
    var columnSet = new Set([...linkerAlwaysFetchColumns, ...filterFetchColumns]);
    return [...columnSet];
  }, [linkerAlwaysFetchColumns, filterFetchColumns]);
  if (fetchResult.status === 'loading') {
    return /*#__PURE__*/_jsx(LoadingOverlay, {
      isLoading: true,
      "data-testid": "grid-widget-plugin-loading"
    });
  }
  if (fetchResult.status === 'error') {
    return /*#__PURE__*/_jsx(LoadingOverlay, {
      "data-testid": "grid-widget-plugin-loading-error",
      errorMessage: getErrorMessage(fetchResult.error),
      isLoading: false
    });
  }
  assertNotNull(model, 'Model should be defined when fetch is successful');
  return /*#__PURE__*/_jsx(IrisGrid, _objectSpread(_objectSpread(_objectSpread(_objectSpread({
    ref: irisGridRef,
    model: model,
    settings: settings,
    onStateChange: handleIrisGridChange,
    onSelectionChanged: setSelection,
    onContextMenu: onContextMenu,
    inputFilters: inputFilters,
    customFilters: customFilters,
    transformTableOptions: transformTableOptions
    // eslint-disable-next-line react/jsx-props-no-spreading
  }, irisGridProps), linkerProps), {}, {
    alwaysFetchColumns: alwaysFetchColumns
    // eslint-disable-next-line react/jsx-props-no-spreading
  }, hydratedState), {}, {
    children: Plugin
  }));
}
export default GridWidgetPlugin;
//# sourceMappingURL=GridWidgetPlugin.js.map